import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AuthGuard} from './auth.guard';
import {GLOBAL} from '../shared/global';

@Injectable()
export class AuthTokenGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return GLOBAL.currentUser && GLOBAL.currentUser.email && !AuthGuard.isTokenInvalid();
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth-token.guard.ts